import { render, staticRenderFns } from "./TrendingPage.vue?vue&type=template&id=3e7e4f48&scoped=true&"
import script from "./TrendingPage.vue?vue&type=script&lang=js&"
export * from "./TrendingPage.vue?vue&type=script&lang=js&"
import style0 from "./TrendingPage.vue?vue&type=style&index=0&id=3e7e4f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e4f48",
  null
  
)

export default component.exports